/**
 * The motion scale for Motion (`motion/react`) transitions: the tokens in
 * motion.css, in seconds and bezier arrays. Pick by what the motion does (the
 * usage table lives in motion.css); tests/motion-tokens.test.ts keeps the two
 * files in step.
 */
export const MOTION_DURATION = {
  stagger: 0.04,
  micro: 0.08,
  quick: 0.15,
  fast: 0.25,
  medium: 0.35,
  slow: 0.4,
  verySlow: 0.5,
} as const

export const MOTION_EASE = {
  smoothOut: [0.22, 1, 0.36, 1],
  bounce: [0.34, 1.36, 0.64, 1],
  bounceStrong: [0.34, 3.85, 0.64, 1],
} as const satisfies Record<string, readonly [number, number, number, number]>

/** Ready-made transitions, named by what moves. */
export const MOTION_TRANSITION = {
  /** A menu, popover or modal opening. */
  surfaceOpen: { duration: MOTION_DURATION.fast, ease: MOTION_EASE.smoothOut },
  /** The same surface closing: quicker than the open, so it gets out of the way. */
  surfaceClose: {
    duration: MOTION_DURATION.quick,
    ease: MOTION_EASE.smoothOut,
  },
  /** An active pill or underline sliding between tabs. */
  slidingIndicator: {
    duration: MOTION_DURATION.fast,
    ease: MOTION_EASE.smoothOut,
  },
  /** A container growing or shrinking to new content. */
  resize: { duration: MOTION_DURATION.fast, ease: MOTION_EASE.smoothOut },
  /** Loaded content replacing a skeleton or filling a panel that just opened. */
  contentReveal: {
    duration: MOTION_DURATION.slow,
    ease: MOTION_EASE.smoothOut,
  },
  /** A label swapping in place. */
  textSwap: { duration: MOTION_DURATION.quick, ease: 'easeInOut' },
  /** A toast rising in. */
  toastOpen: { duration: MOTION_DURATION.medium, ease: MOTION_EASE.smoothOut },
  /** A toast leaving. */
  toastClose: { duration: MOTION_DURATION.fast, ease: MOTION_EASE.smoothOut },
} as const
